// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"d4c70363","231":"e9a2941a","309":"3d57c290","331":"6d855829","332":"50324f59","404":"63772c46","424":"98b7fd2b","485":"27fb1230","858":"beec0ea6","873":"5e83187f","900":"b46f9476","999":"c97bab1d"}[chunkId] + ".chunk.js";
};